import Cookies from 'js-cookie'

import { VPN_NOTICE_COOKIE_NAME, VPN_NOTICE_COOKIE_TTL_HOURS } from '../model/constants'

const getCookieDomain = (): string | undefined => {
	if (typeof window === 'undefined') {
		return undefined
	}

	const host = window.location.hostname

	return host === 'iport.ru' || host.endsWith('.iport.ru') ? '.iport.ru' : undefined
}

export const hasVpnNoticeCookie = (): boolean => Boolean(Cookies.get(VPN_NOTICE_COOKIE_NAME))

export const setVpnNoticeCookie = (): void => {
	const domain = getCookieDomain()

	Cookies.set(VPN_NOTICE_COOKIE_NAME, 'true', {
		expires: new Date(Date.now() + VPN_NOTICE_COOKIE_TTL_HOURS * 60 * 60 * 1000),
		path: '/',
		...(domain ? { domain } : {})
	})
}
